<template>
  <div class="contact-container">
    <div class="image-container">
      <div class="row">
        <img :src="imgList" />
      </div>
    </div>
    <!-- <div class="contact-text">
      聯絡我們<br />
      Whatsapp：+852 69597345<br />
      客戶服務熱線：+852 28662500<br />
      電郵：sales@chrgiepower.com
    </div>
    <div class="orange-line"></div>
    <div class="contact-image">
      <img src="@/assets/contact-us.png" alt="聯絡我們圖片" />
    </div> -->
    <!-- <viewFooter></viewFooter> -->
  </div>
</template>
<script>
// import viewFooter from '@/views/view-footer.vue'
export default {
  name: "ContactUs",
  components: {
    // viewFooter
   },
  data() {
    return {
      imgList:require('@/assets/contact-usnew.png')
    };
  },
};
</script>
<style scoped>
.row {
  display: flex;
  justify-content: center;
  align-items: center;
}
.row img {
  width: 97%; /* 图片宽度改为屏幕宽度的 80% */
  /* max-width: 1200px;  */
  height: auto;
  object-fit: contain; /* 保持比例，不裁切 */
  display: block;
  border-radius: 8px; /* 图片四角微微圆润，更美观 */
}

/* 大屏（1920px+） */
@media (min-width: 1920px) {
  .row img {
    width: 98%; /* 大屏图片更小 */
    /* max-width: 1400px; */
  }
}

/* 平板（768px ~ 1023px） */
@media (max-width: 1023px) and (min-width: 768px) {
  .row img {
    width: 98%;
  }
}

/* 手机（小于 768px） */
@media (max-width: 767px) {
  .row img {
    width: 100%;
    max-width: 100%;
  }
}
</style>
